import React from "react";
import { Extensions, generateHTML } from "@tiptap/core";
import { websiteBuilderGetRichTextResponsiveFontSizeStyles } from "../extensions/websiteBuilderRichTextResponsiveFontSize";
import { TWebsiteBuilderRichTextContent } from "../websiteBuilderRichTextContent";

export const WEBSITE_BUILDER_RICH_TEXT_CLASS_NAME = "website-builder-rich-text";

export interface IWebsiteBuilderRichTextRenderOptions {
  content: TWebsiteBuilderRichTextContent;
  extensions: Extensions;
}

export function websiteBuilderRenderRichTextToReact(options: IWebsiteBuilderRichTextRenderOptions) {
  return React.createElement("div", {
    className: WEBSITE_BUILDER_RICH_TEXT_CLASS_NAME,
    style: websiteBuilderGetRichTextResponsiveFontSizeStyles(options.content.attrs.responsiveFontSize),
    dangerouslySetInnerHTML: {
      __html: generateHTML(options.content, options.extensions),
    },
  });
}

export function websiteBuilderRenderRichTextToHTML(options: IWebsiteBuilderRichTextRenderOptions): string {
  const container = document.createElement("div");
  container.className = WEBSITE_BUILDER_RICH_TEXT_CLASS_NAME;
  container.innerHTML = generateHTML(options.content, options.extensions);

  const styles = websiteBuilderGetRichTextResponsiveFontSizeStyles(options.content.attrs.responsiveFontSize);

  Object.entries(styles).forEach(([name, value]) => {
    if (value != null) {
      container.style.setProperty(name, value);
    }
  });

  return container.outerHTML;
}
